// extracted by css-extract-rspack-plugin
export default {"list":"wLWB1C","unlisted":"oy_xA2"};